The response from the `updateUploadedCandidateProfileActions` mutation.
